import React, { useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion, useInView } from 'framer-motion';

const SERVICIOS = [
  {
    icon: 'fa-solid fa-display',
    titulo: 'Web Estática',
    subtitulo: 'Para autónomos y pequeños negocios',
    descripcion: 'Presencia rápida y profesional en internet. Perfecta para atraer clientes locales y aparecer en las búsquedas de Google. Incluye diseño adaptado a móvil, formulario de contacto y optimización SEO básica.',
    incluye: ['Hasta 5 secciones', 'Google Maps integrado', 'Formulario de contacto', 'Diseño responsive (móvil, tablet, ordenador)', 'Dominio .es + Alojamiento 1 año'],
    color: '#2e8bc0',
  },
  {
    icon: 'fa-solid fa-bolt',
    titulo: 'Web Mediana',
    subtitulo: 'Para empresas en crecimiento',
    descripcion: 'Una web dinámica con varias secciones, catálogo de servicios o productos, blog y panel de gestión de contenido para actualizarla sin conocimientos técnicos.',
    incluye: ['Hasta 15 páginas', 'Panel de gestión de contenido', 'Catálogo de productos o servicios', 'Blog integrado', 'Formularios avanzados', 'Seguimiento de visitas'],
    color: '#f0ad4e',
    destacado: true,
  },
  {
    icon: 'fa-solid fa-cart-shopping',
    titulo: 'Tienda Online',
    subtitulo: 'Comercio electrónico completo',
    descripcion: 'Vende tus productos o servicios las 24 horas del día, los 7 días de la semana. Pasarela de pago, gestión de pedidos y panel de administración personalizado para tu negocio.',
    incluye: ['Productos ilimitados', 'Pago con tarjeta y Bizum', 'Gestión de pedidos y stock', 'Panel de administración', 'Facturación automática', 'Integración con redes sociales'],
    color: '#5cb85c',
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.15 } }),
};

const Servicios = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  const irAPrecios = () => {
    const el = document.getElementById('precios');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  };

  return (
    <section id="servicios" style={{ background: 'var(--bg-surface)' }}>
      <Container>
        <div className="text-center mb-5" ref={ref}>
          <motion.span className="badge-primary mb-3 d-inline-block" initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}}>
            Nuestros servicios
          </motion.span>
          <motion.h2 className="section-title" initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: 0.1 }}>
            ¿Qué tipo de web necesitas?
          </motion.h2>
          <div className="accent-line center" />
          <motion.p className="section-subtitle" initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}} transition={{ delay: 0.2 }}>
            Elige el plan que mejor se adapte a tu negocio. Todos incluyen diseño personalizado y soporte.
          </motion.p>
        </div>

        <Row className="g-4 justify-content-center">
          {SERVICIOS.map((srv, i) => (
            <Col key={srv.titulo} lg={4} md={6}>
              <motion.div custom={i} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} style={{ height: '100%' }}>
                <div
                  className="card-dark"
                  style={{
                    height: '100%', display: 'flex', flexDirection: 'column',
                    position: 'relative', overflow: 'hidden',
                    borderColor: srv.destacado ? srv.color : undefined,
                    boxShadow: srv.destacado ? `0 0 30px ${srv.color}28` : undefined,
                  }}
                >
                  {srv.destacado && (
                    <div style={{ position: 'absolute', top: '18px', right: '18px', background: srv.color, color: 'white', fontSize: '0.7rem', fontFamily: 'var(--font-heading)', fontWeight: 600, padding: '4px 12px', borderRadius: '50px', letterSpacing: '0.5px' }}>
                      MÁS POPULAR
                    </div>
                  )}

                  {/* Franja de color superior */}
                  <div style={{ height: '3px', background: `linear-gradient(90deg, ${srv.color}, transparent)`, margin: '-2rem -2rem 1.5rem' }} />

                  <div style={{ width: '54px', height: '54px', borderRadius: '14px', background: `${srv.color}18`, border: `1px solid ${srv.color}30`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.2rem' }}>
                    <i className={srv.icon} style={{ color: srv.color, fontSize: '1.4rem' }} />
                  </div>

                  <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'white', marginBottom: '0.3rem', fontFamily: 'var(--font-heading)' }}>
                    {srv.titulo}
                  </h3>
                  <p style={{ color: srv.color, fontSize: '0.83rem', fontWeight: 600, marginBottom: '0.9rem', fontFamily: 'var(--font-heading)', letterSpacing: '0.3px' }}>
                    {srv.subtitulo}
                  </p>
                  <p style={{ color: '#8fa3bf', fontSize: '0.91rem', lineHeight: 1.7, marginBottom: '1.4rem', flexGrow: 1 }}>
                    {srv.descripcion}
                  </p>

                  <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem' }}>
                    {srv.incluye.map(item => (
                      <li key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', color: '#c8d8ec', fontSize: '0.87rem', marginBottom: '7px' }}>
                        <i className="fa-solid fa-check" style={{ color: srv.color, fontSize: '0.75rem', marginTop: '4px', flexShrink: 0 }} />
                        {item}
                      </li>
                    ))}
                  </ul>

                  <button className="btn-primary-custom mt-auto w-100" onClick={irAPrecios} style={{ padding: '12px', justifyContent: 'center' }}>
                    Solicitar presupuesto
                  </button>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>

        <motion.div className="text-center mt-5" initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}} transition={{ delay: 0.65 }}>
          <p style={{ color: '#6a86a8', fontSize: '0.88rem', marginBottom: '6px' }}>
            ¿Necesitas algo diferente? Cuéntanoslo y te preparamos un presupuesto a medida sin ningún compromiso.
          </p>
          <a href="mailto:info@webfacilcastellon.es" style={{ color: '#45a8e0', fontWeight: 600, fontSize: '0.92rem', textDecoration: 'none' }}>
            <i className="fa-solid fa-envelope me-2" style={{ fontSize: '0.85rem' }} />
            info@webfacilcastellon.es
          </a>
        </motion.div>
      </Container>
    </section>
  );
};

export default Servicios;
